import type { Slice } from './slice'
import { SLICE_KEY } from './slice'

/**
 * Partialize channels state for local storage
 */
export function partialize(_state: Slice) {
  return {}
}

/**
 * Merges the persisted data with the current state
 */
export function merge(persistedState: Slice, currentState: Slice) {
  return {
    [SLICE_KEY]: {
      ...currentState[SLICE_KEY],
      ...persistedState[SLICE_KEY],
    },
  }
}
